import { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Context } from '../../../../context/AppContext';
import { getNestedValue } from '../../common/utils/helpers';
import { KEYWORD_INPUT_ID } from '../../constants';
import { useSearchContext } from '../../context/Search';

const useSearchModalConsumerLogic = () => {
  const {
    modal: [modal],
  } = useSearchContext();
  const {
    media: { mobile },
  } = useContext(Context);
  const { setFocus } = useFormContext();

  /**
   * When the modal opens, set focus based on the following priority:
   * - `focusedInput` data value passed to modal
   * - Keyword input field
   */
  useEffect(() => {
    if (modal.show) {
      const focusedInput = getNestedValue(modal, 'data', 'focusedInput');
      if (focusedInput) {
        setFocus(focusedInput);
      } else {
        setFocus(KEYWORD_INPUT_ID);
      }
    }
  }, [modal]);

  return { mobile, showModal: modal.show };
};

export default useSearchModalConsumerLogic;
